import AuthorizationService from "../services/AuthorizationService";

import AuthenticationHelper from "./../helper/OIDCManager";
import { AbilityBuilder, createMongoAbility, MongoAbility } from "@casl/ability";
import { IResource } from "../models/resource";

// Singleton partageable hors des composants Vue (ex: guards du router)
export const appAbility: MongoAbility = createMongoAbility([]);

const auth = new AuthenticationHelper();

export async function fetchUserRights(): Promise<MongoAbility> {
    const { can, build } = new AbilityBuilder(createMongoAbility);

    let userToken = await auth.getAccessToken();

    const user = await auth.getUserInfo();
    const isExpired = !user || (user.expires_at != null && user.expires_at < Math.floor(Date.now() / 1000));
    console.log("Token expiré :", isExpired);

    if (userToken != undefined) {
        let resources: Array<IResource> = await AuthorizationService.getMyFrontResources()

        if(resources) {
            if (resources.length > 0) {
                resources.forEach((resource) => {
                    can(resource.action, resource.context + '#' + resource.resource);
                });
            }
        }

        //Mise à jour en fonction des centres de l'utilisateur
        // TODO : revoir la logique d'accès aux centres
        // if (userStore.currentUser.centersUser?.length > 0) {
        //     can("access", "centeruser");
        // }
    }

    appAbility.update(build().rules);
    return appAbility;
}